import { render } from "./AccountSecuritySettings.vue?vue&type=template&id=8cc35734"
import script from "./AccountSecuritySettings.vue?vue&type=script&lang=js"
export * from "./AccountSecuritySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__